module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 414
// module chunks = 0